import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  List,
  ListItem,
  Switch,
  TextField,
} from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection } from '../../TabSections';
import { SECTIONS } from '../../constants';
import {
  SELF_GUIDED_TOURS_CONFIG,
  SELF_GUIDED_TOURS_TEXT_FIELDS_ORDERED,
} from './constants';
import { selfGuidedToursPropTypes } from '../../../../prop-types';

const { DESCRIPTION, TITLE } = SECTIONS.SELF_GUIDED_TOURS;

const TOURS_EXPORT_ONLY_FAVORITE_UNIT =
  SELF_GUIDED_TOURS_CONFIG.TOURS_EXPORT_ONLY_FAVORITE_UNIT;

const SelfGuidedTours = ({
  clearFieldErrorMessage,
  selfGuidedTours = {},
  updateSelfGuidedTours,
  validationErrorMessages,
}) => {
  const handleOnBlur = ({ target: { name, value } }) => {
    updateSelfGuidedTours({ [name]: value.trim() });
  };

  const handleOnFocus = ({ target: { name } }) => {
    const validationErrorMessage = validationErrorMessages?.[name];
    if (validationErrorMessage) {
      clearFieldErrorMessage(name);
    }
  };

  const handleSwitchToggle = ({ target: { name, checked } }) => {
    updateSelfGuidedTours({ [name]: checked });
  };

  const handleOnInputChange = (value, { target: { name } }) => {
    updateSelfGuidedTours({ [name]: value });
  };

  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      <Flex flexDirection="column" gap={16}>
        <List>
          <ListItem
            divider
            endSlot={
              <Switch
                aria-label={`${TOURS_EXPORT_ONLY_FAVORITE_UNIT.PRIMARY} switch`}
                checked={
                  selfGuidedTours[TOURS_EXPORT_ONLY_FAVORITE_UNIT.NAME] ?? false
                }
                name={TOURS_EXPORT_ONLY_FAVORITE_UNIT.NAME}
                onChange={handleSwitchToggle}
              />
            }
            primary={TOURS_EXPORT_ONLY_FAVORITE_UNIT.PRIMARY}
            secondary={TOURS_EXPORT_ONLY_FAVORITE_UNIT.SECONDARY}
          />
        </List>

        <Flex flexDirection="column" gap={16}>
          {SELF_GUIDED_TOURS_TEXT_FIELDS_ORDERED.map(
            ({ NAME, LABEL, PLACEHOLDER, HELPER_TEXT }) => {
              const validationErrorMessage = validationErrorMessages?.[NAME];
              const helperText = validationErrorMessage || HELPER_TEXT;

              return (
                <TextField
                  error={Boolean(validationErrorMessage)}
                  helperText={helperText}
                  id={`knck-self-guided-${NAME}`}
                  key={NAME}
                  label={LABEL}
                  name={NAME}
                  onBlur={handleOnBlur}
                  onChange={handleOnInputChange}
                  onFocus={handleOnFocus}
                  placeholder={PLACEHOLDER}
                  value={selfGuidedTours[NAME] ?? ''}
                  variant="outlined"
                />
              );
            }
          )}
        </Flex>
      </Flex>
    </DividedTabSection>
  );
};

SelfGuidedTours.propTypes = {
  clearFieldErrorMessage: PropTypes.func,
  selfGuidedTours: selfGuidedToursPropTypes,
  updateSelfGuidedTours: PropTypes.func,
  validationErrorMessages: PropTypes.objectOf(PropTypes.string),
};

export default memo(SelfGuidedTours);
